(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-moments"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeSharedMoments() {
    const sections = document.querySelectorAll('.shared-moments');

    sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const container = section.querySelector('[data-ticker-container]');
      const track = section.querySelector('[data-ticker-track]');
      const lightbox = section.querySelector('[data-shared-lightbox]');
      const lightboxContent = section.querySelector('[data-lightbox-content]');
      const lightboxCaption = section.querySelector('[data-lightbox-caption]');
      const lightboxClose = section.querySelector('[data-lightbox-close]');

      if (!container || !track) return;

      // Duplicate blocks to build continuous loop
      const originalCards = Array.from(track.children);
      originalCards.forEach(function (card) {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-cloned', 'true');
        track.appendChild(clone);
      });

      let offset = 0;
      const speed = 0.6;
      let isPaused = false;
      let isAudioPlaying = false;
      let isDragging = false;
      let startX = 0;
      let prevOffset = 0;
      let wheelTimeout = null;

      function getHalfWidth() {
        return track.scrollWidth / 2;
      }

      function applyOffset(newOffset) {
        const halfWidth = getHalfWidth();
        if (halfWidth <= 0) return;
        offset = newOffset % halfWidth;
        if (offset < 0) offset += halfWidth;
        track.style.transform = `translate3d(-${offset}px, 0, 0)`;
      }

      function loop() {
        if (!isPaused && !isAudioPlaying && !isDragging) {
          applyOffset(offset + speed);
        }
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);

      // Trackpad swipe
      container.addEventListener('wheel', function (e) {
        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
        if (Math.abs(delta) > 0) {
          e.preventDefault();
          isPaused = true;
          applyOffset(offset + delta);

          clearTimeout(wheelTimeout);
          wheelTimeout = setTimeout(function () {
            isPaused = false;
          }, 800);
        }
      }, { passive: false });

      // Drag & Swipe handling
      function onTouchStart(e) {
        // Prevent drag initiation if user is clicking mute button
        if (e.target.closest('[data-mute-btn]')) return;

        isDragging = true;
        isPaused = true;
        startX = e.touches ? e.touches[0].pageX : e.pageX;
        prevOffset = offset;
      }

      function onTouchMove(e) {
        if (!isDragging) return;
        const currentX = e.touches ? e.touches[0].pageX : e.pageX;
        const diff = startX - currentX;
        applyOffset(prevOffset + diff);
      }

      function onTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
      }

      container.addEventListener('touchstart', onTouchStart, { passive: true });
      container.addEventListener('touchmove', onTouchMove, { passive: true });
      container.addEventListener('touchend', onTouchEnd, { passive: true });

      container.addEventListener('mousedown', onTouchStart);
      window.addEventListener('mousemove', onTouchMove);
      window.addEventListener('mouseup', onTouchEnd);

      // Desktop Card Hover
      track.addEventListener('mouseover', function (e) {
        const card = e.target.closest('[data-shared-moment]');
        if (!card) return;

        isPaused = true;

        const video = card.querySelector('video');
        if (video && window.matchMedia('(hover: hover)').matches) {
          video.play().catch(function () {});
          card.classList.add('is-playing');
        }
      });

      track.addEventListener('mouseout', function (e) {
        const card = e.target.closest('[data-shared-moment]');
        const related = e.relatedTarget;
        if (!card || card.contains(related)) return;

        const video = card.querySelector('video');
        if (video) {
          video.pause();
          video.muted = true;
          card.classList.remove('is-playing');

          const btnText = card.querySelector('.sm-btn-text');
          if (btnText) btnText.textContent = '🔇 UNMUTE';
        }

        isPaused = false;
        isAudioPlaying = false;
      });

      // Mute / Unmute Button Click
      track.addEventListener('click', function (e) {
        const muteBtn = e.target.closest('[data-mute-btn]');
        if (!muteBtn) return;

        e.stopPropagation();
        e.preventDefault();

        const card = muteBtn.closest('[data-shared-moment]');
        const video = card ? card.querySelector('video') : null;
        if (!video) return;

        // Mute all other videos
        track.querySelectorAll('video').forEach(function (v) {
          if (v !== video) {
            v.muted = true;
            const otherBtn = v.closest('[data-shared-moment]').querySelector('.sm-btn-text');
            if (otherBtn) otherBtn.textContent = '🔇 UNMUTE';
          }
        });

        const btnText = muteBtn.querySelector('.sm-btn-text');

        if (video.muted) {
          video.muted = false;
          video.play().catch(function () {});
          isAudioPlaying = true;
          isPaused = true;
          if (btnText) btnText.textContent = '🔊 MUTE';
        } else {
          video.muted = true;
          isAudioPlaying = false;
          if (btnText) btnText.textContent = '🔇 UNMUTE';
        }
      }, true);

      // Lightbox Trigger
      track.addEventListener('click', function (e) {
        if (e.target.closest('[data-mute-btn]')) return;

        const trigger = e.target.closest('[data-lightbox-trigger]');
        if (!trigger) return;

        const mediaType = trigger.getAttribute('data-media-type');
        const card = trigger.closest('[data-shared-moment]');
        const caption = card ? card.querySelector('[data-caption]') : null;

        const cardVideo = card ? card.querySelector('video') : null;
        if (cardVideo) cardVideo.pause();

        lightboxContent.innerHTML = '';

        if (mediaType === 'video') {
          const videoSrc = trigger.getAttribute('data-video-src');
          const modalVideo = document.createElement('video');
          modalVideo.src = videoSrc;
          modalVideo.controls = true;
          modalVideo.autoplay = true;
          modalVideo.muted = false;
          modalVideo.loop = true;
          modalVideo.playsInline = true;
          lightboxContent.appendChild(modalVideo);
          modalVideo.play().catch(function () {});
        } else if (mediaType === 'image') {
          const imageSrc = trigger.getAttribute('data-image-src');
          const modalImg = document.createElement('img');
          modalImg.src = imageSrc;
          lightboxContent.appendChild(modalImg);
        }

        if (caption && caption.innerHTML.trim() !== '') {
          lightboxCaption.innerHTML = caption.innerHTML;
          lightboxCaption.style.display = 'block';
        } else {
          lightboxCaption.style.display = 'none';
        }

        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      function closeLightbox() {
        if (!lightbox) return;
        const activeVid = lightbox.querySelector('video');
        if (activeVid) activeVid.pause();

        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        lightboxContent.innerHTML = '';
        document.body.style.overflow = '';
      }

      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (event) {
          if (event.target === lightbox) closeLightbox();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) {
          closeLightbox();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSharedMoments);
  } else {
    initializeSharedMoments();
  }

  document.addEventListener('shopify:section:load', initializeSharedMoments);
})();

  } catch(e) { console.error(e); }
})();
})();
